(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["announcement-bar"] && !Shopify.designMode) return;
  try {
    // Announcement bar close functionality - updated
  document.addEventListener('DOMContentLoaded', function() {
    const closeButton = document.querySelector('[data-announcement-close]');
    const announcementBar = document.querySelector('.announcement-bar');
    
    if (closeButton && announcementBar) {
      closeButton.addEventListener('click', function() {
        announcementBar.style.display = 'none';
        
        // Store in localStorage to remember user's choice
        localStorage.setItem('announcement-closed', 'true');
      });
    }
    
    // Check if user previously closed the announcement
    if (localStorage.getItem('announcement-closed') === 'true') {
      if (announcementBar) {
        announcementBar.style.display = 'none';
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-carousel-snippet"] && !Shopify.designMode) return;
  try {
    // Product Carousel Snippet JavaScript - Clean Version
document.addEventListener('DOMContentLoaded', function() {
  // Carousel navigation functionality
  const carousels = document.querySelectorAll('.product-carousel');
  
  carousels.forEach(carousel => {
    const scroller = carousel.querySelector('.product-carousel__scroller');
    const prev = carousel.querySelector('.product-carousel__btn--prev');
    const next = carousel.querySelector('.product-carousel__btn--next');
    
    if (scroller && prev && next) {
      const computeStep = () => {
        const first = scroller.firstElementChild;
        if (!first) return 300;
        const style = getComputedStyle(scroller);
        const gap = parseInt(style.columnGap || style.gap || 16, 10) || 16;
        return first.getBoundingClientRect().width + gap;
      };
      
      prev.addEventListener('click', function(e) { 
        e.preventDefault(); 
        scroller.scrollBy({ left: -computeStep(), behavior: 'smooth' }); 
      });
      
      next.addEventListener('click', function(e) { 
        e.preventDefault(); 
        scroller.scrollBy({ left: computeStep(), behavior: 'smooth' }); 
      });
    }
  });

  // Choose options functionality
  const chooseOptionButtons = document.querySelectorAll('[data-choose-option]');
  const productDetailsPanels = document.querySelectorAll('[data-product-details]');
  const closeButtons = document.querySelectorAll('[data-product-details-close]');

  chooseOptionButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const productId = this.getAttribute('data-product-id');
      const productHandle = this.getAttribute('data-product-handle');
      const productCard = this.closest('.product-card');
      const carousel = productCard.closest('.product-carousel');
      
      // First, hide all currently visible panels
      const allPanels = document.querySelectorAll('[data-product-details]');
      allPanels.forEach(panel => {
        panel.style.display = 'none';
      });
      
      // Find the target panel - search in the entire document, not just visible ones
      let targetPanel = document.querySelector(`[data-product-details][data-product-id="${productId}"]`);
      
      console.log('Looking for panel with product ID:', productId, 'Type:', typeof productId);
      console.log('Found target panel:', targetPanel);
      
      // Debug: List all available panels and their IDs
      const allAvailablePanels = document.querySelectorAll('[data-product-details]');
      console.log('All available panels:', allAvailablePanels.length);
      allAvailablePanels.forEach((panel, index) => {
        console.log(`Panel ${index}:`, panel.getAttribute('data-product-id'), 'Type:', typeof panel.getAttribute('data-product-id'));
      });
      
      if (targetPanel) {
        // Ensure the panel is in the carousel container
        if (targetPanel.parentNode !== carousel) {
          console.log('Moving panel to carousel container');
          carousel.appendChild(targetPanel);
        }
        
        // Show the target panel
        targetPanel.style.display = 'block';
        console.log('Panel displayed for product:', productId);
        
        // Initialize product details functionality for the new panel
        setTimeout(() => {
          if (typeof window.initProductDetails === 'function') {
            console.log('Initializing product details for panel');
            window.initProductDetails(targetPanel);
          }
        }, 100);
        
        // Scroll to the panel smoothly
        targetPanel.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'start',
          inline: 'nearest'
        });
      } else {
        // If no panel exists, redirect to product page
        console.log('No panel found for product ID:', productId);
        console.log('Available panels:', document.querySelectorAll('[data-product-details]'));
        window.location.href = `/products/${productHandle}`;
      }
    });
  });

  // Close panel functionality
  closeButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const panel = this.closest('[data-product-details]');
      if (panel) {
        panel.style.display = 'none';
        // Panel is already in the carousel, no need to move it
      }
    });
  });

  // Close panel when clicking outside
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('product-details-panel')) {
      e.target.style.display = 'none';
      // Panel is already in the carousel, no need to move it
    }
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-modal"] && !Shopify.designMode) return;
  try {
    // Search modal functionality
(function initSearchModal() {
  function escapeHTML(str) {
    if (typeof str !== 'string') return '';
    return str.replace(/[&<>'"]/g, tag => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
    }[tag] || tag));
  }

  function setup() {
    const searchModal = document.querySelector('[data-search-modal]');
    if (!searchModal) return;
    
    // Translations
    const transSearching = searchModal.dataset.i18nSearching || 'Searching...';
    const transLoading = searchModal.dataset.i18nLoading || 'Loading products...';
    const transNoSuggestions = searchModal.dataset.i18nNoSuggestions || 'No suggestions';

    const searchToggles = document.querySelectorAll('[data-search-toggle]');
    const searchClose = searchModal.querySelectorAll('[data-search-close]');
    const searchInput = searchModal.querySelector('[data-search-input]');
    const searchClear = searchModal.querySelector('[data-search-clear]');
    const searchSuggestions = searchModal.querySelectorAll('[data-suggestion]');
    const searchForm = searchModal.querySelector('.search-form');
    const searchResults = searchModal.querySelector('[data-search-results]');
    const suggestionsList = searchModal.querySelector('[data-suggestions-list]');
    const productsGrid = searchModal.querySelector('[data-products-grid]');
    const viewAllSearch = searchModal.querySelector('[data-view-all-search]');
    const searchTermSpan = searchModal.querySelector('[data-search-term]');

    // Open search modal (attach to all toggles)
    if (searchToggles.length && searchModal) {
      searchToggles.forEach(btn => {
        btn.addEventListener('click', function() {
          searchModal.classList.add('is-active');
          if (searchInput) {
            setTimeout(() => searchInput.focus(), 100);
          }
          document.body.style.overflow = 'hidden';
        });
      });
    }

    // Close search modal
    if (searchClose.length > 0 && searchModal) {
      searchClose.forEach(closeBtn => {
        closeBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          searchModal.classList.remove('is-active');
          document.body.style.overflow = '';
          if (searchInput) {
            searchInput.value = '';
          }
          hideSearchResults();
        });
      });
    }

  // Prevent modal content clicks from closing modal
    if (searchModal) {
      const modalContent = searchModal.querySelector('.search-modal__content');
      if (modalContent) {
        modalContent.addEventListener('click', function(e) {
          e.stopPropagation();
        });
      }
    }

  // Clear search input
    if (searchClear && searchInput) {
      searchClear.addEventListener('click', function() {
        searchInput.value = '';
        searchInput.focus();
        hideSearchResults();
      });
    }

  // Handle suggestion clicks
    if (searchSuggestions.length > 0 && searchInput) {
      searchSuggestions.forEach(suggestion => {
        suggestion.addEventListener('click', function() {
          const query = this.getAttribute('data-suggestion');
          searchInput.value = query;
          if (searchForm) {
            searchForm.submit();
          }
        });
      });
    }

  // Handle search form submission
    if (searchForm && searchModal) {
      searchForm.addEventListener('submit', function() {
        searchModal.classList.remove('is-active');
        document.body.style.overflow = '';
      });
    }

  // Dynamic search functionality
    let searchTimeout;
    
    if (searchInput) {
      searchInput.addEventListener('input', function() {
        const query = this.value.trim();
        
        if (searchTimeout) {
          clearTimeout(searchTimeout);
        }
        
        if (query.length >= 2) {
          searchTimeout = setTimeout(() => {
            performSearch(query);
          }, 300);
        } else {
          hideSearchResults();
        }
      });
    }
  
  // Perform search function
    function performSearch(query) {
    // Update search term in view all link
      if (searchTermSpan) {
        searchTermSpan.textContent = query;
      }
      if (viewAllSearch) {
        viewAllSearch.href = `/search?q=${encodeURIComponent(query)}`;
      }
    
    // Show loading state
      showSearchResults();
      if (suggestionsList) {
        suggestionsList.innerHTML = `<div class="search-modal__suggestion-item">${transSearching}</div>`;
      }
      if (productsGrid) {
        productsGrid.innerHTML = `<div>${transLoading}</div>`;
      }

      // Predictive search (existing resources only)
      const suggestUrl = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection&resources[limit]=6`;
      fetch(suggestUrl)
        .then(response => {
          if (!response.ok) throw new Error('Predictive search failed');
          return response.json();
        })
        .then(data => {
          const products = (data.resources && data.resources.results && data.resources.results.products) || [];
          const collections = (data.resources && data.resources.results && data.resources.results.collections) || [];

          // Build suggestions from existing collections/products only
          if (suggestionsList) {
            const items = [];
            collections.slice(0, 4).forEach(c => {
              items.push(`<div class="search-modal__suggestion-item" data-suggestion="${escapeHTML(c.title)}">${escapeHTML(c.title)}</div>`);
            });
            if (items.length < 4) {
              products.slice(0, 4 - items.length).forEach(p => {
                items.push(`<div class="search-modal__suggestion-item" data-suggestion="${escapeHTML(p.title)}">${escapeHTML(p.title)}</div>`);
              });
            }
            suggestionsList.innerHTML = items.join('') || `<div class=\"search-modal__suggestion-item\">${transNoSuggestions}</div>`;

            suggestionsList.querySelectorAll('[data-suggestion]').forEach(item => {
              item.addEventListener('click', function() {
                if (!searchInput || !searchForm) return;
                searchInput.value = this.textContent;
                searchForm.submit();
              });
            });
          }

          if (productsGrid) {
            if (products.length > 0) {
              productsGrid.innerHTML = products.map(p => `
                <a href="${escapeHTML(p.url)}" class="search-modal__product-item">
                  <div class="search-modal__product-image">
                    ${p.image ? `<img src="${escapeHTML(p.image)}" alt="${escapeHTML(p.title)}" loading="lazy">` : ''}
                  </div>
                  <div class="search-modal__product-title">${escapeHTML(p.title)}</div>
                  <div class="search-modal__product-price">${p.price ? escapeHTML(p.price) : ''}</div>
                </a>
              `).join('');
            } else {
              // Fallback to regular search page parsing when predictive returns no products
              fetchSearchResultsFallback(query);
            }
          }
        })
        .catch(() => {
          // Fallback to regular search page parsing
          fetchSearchResultsFallback(query);
        });
      }
  
  // Fallback search function
    function fetchSearchResultsFallback(query) {
    
    // Try using the regular search page with AJAX
      fetch(`/search?q=${encodeURIComponent(query)}`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Fallback search failed');
        }
        return response.text();
      })
      .then(html => {
        
        // Parse the HTML response to extract product data
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const productElements = doc.querySelectorAll('.collection-product, .product-card, [data-product]');
        
        const products = Array.from(productElements).slice(0, 5).map(element => {
          const titleElement = element.querySelector('h3, .product-title, [data-product-title], .collection-product__title');
          const title = titleElement ? titleElement.textContent.trim() : 'Product';
          const linkElement = element.querySelector('a');
          const link = linkElement ? linkElement.href : '#';
          const imageElement = element.querySelector('img');
          const image = imageElement ? imageElement.src : '';
          const priceElement = element.querySelector('.price, .product-price, [data-price], .collection-product__price');
          const price = priceElement ? priceElement.textContent.trim() : '';
          
          return { title, url: link, image, price };
        });
        
        displaySearchResults({ products }, query);
      })
      .catch(error => {
        // Third try: Get products from collections
        fetchProductsFromCollections(query);
      });
    }
  
  // Fetch products from collections as fallback
    function fetchProductsFromCollections(query) {
    
    // Try to get products from the main collections
    const collections = ['sneakers', 'streetwear', 'accessories'];
    let productsFound = [];
    let completedRequests = 0;
    
    collections.forEach(collection => {
      fetch(`/collections/${collection}?view=json`)
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error(`Collection ${collection} not found`);
        })
        .then(data => {
          if (data.products) {
            const matchingProducts = data.products.filter(product => 
              product.title.toLowerCase().includes(query.toLowerCase()) ||
              product.vendor.toLowerCase().includes(query.toLowerCase()) ||
              product.type.toLowerCase().includes(query.toLowerCase())
            );
            productsFound = productsFound.concat(matchingProducts.slice(0, 2)); // Limit to 2 per collection
          }
        })
        .catch(error => {
          /* noop */
        })
        .finally(() => {
          completedRequests++;
          if (completedRequests === collections.length) {
            if (productsFound.length > 0) {
              displaySearchResults({ products: productsFound }, query);
            } else {
              if (productsGrid) {
                productsGrid.innerHTML = `<div>No products found for "${escapeHTML(query)}"</div>`;
              }
            }
          }
        });
    });
    }
  
  // Mock results for testing
    function displayMockResults(query) {
    const mockProducts = [
      {
        title: 'Nike ' + query + ' Sneakers',
        url: '/products/nike-' + query.toLowerCase().replace(/\s+/g, '-'),
        image: 'https://via.placeholder.com/200x200?text=Nike',
        price: '€120.00'
      },
      {
        title: 'Adidas ' + query + ' Shoes',
        url: '/products/adidas-' + query.toLowerCase().replace(/\s+/g, '-'),
        image: 'https://via.placeholder.com/200x200?text=Adidas',
        price: '€95.00'
      },
      {
        title: query + ' Collection',
        url: '/collections/' + query.toLowerCase().replace(/\s+/g, '-'),
        image: 'https://via.placeholder.com/200x200?text=Collection',
        price: 'From €80.00'
      }
    ];
    
    displaySearchResults({ products: mockProducts }, query);
    }
  
  // Display search results
    function displaySearchResults(data, query) {
    
    // Display suggestions
      if (suggestionsList) {
      // Create simple suggestions based on the query
      const suggestions = [
        query,
        query + ' shoes',
        query + ' sneakers',
        'Nike ' + query,
        'Adidas ' + query
      ].slice(0, 4);
      
      suggestionsList.innerHTML = suggestions.map(suggestion => 
          `<div class="search-modal__suggestion-item" data-suggestion="${escapeHTML(suggestion)}">${escapeHTML(suggestion)}</div>`
        ).join('');
        
        // Add click handlers to suggestions (submit the modal form)
        suggestionsList.querySelectorAll('[data-suggestion]').forEach(item => {
          item.addEventListener('click', function() {
            if (!searchInput || !searchForm) return;
            searchInput.value = this.textContent;
            searchForm.submit();
          });
        });
      }
    
    // Display products
      if (productsGrid) {
      const products = data.products || data.results || (data.resources && data.resources.results) || [];
      
      if (products.length > 0) {
        productsGrid.innerHTML = products.map(product => `
          <a href="${escapeHTML(product.url)}" class="search-modal__product-item">
            <div class="search-modal__product-image">
              ${product.image ? `<img src="${escapeHTML(product.image)}" alt="${escapeHTML(product.title)}" loading="lazy">` : ''}
            </div>
            <div class="search-modal__product-title">${escapeHTML(product.title)}</div>
            <div class="search-modal__product-price">${product.price ? escapeHTML(product.price) : ''}</div>
          </a>
        `).join('');
      } else {
        productsGrid.innerHTML = `<div>No products found for "${escapeHTML(query)}"</div>`;
      }
      }
    }
  
  // Show search results
    function showSearchResults() {
      if (searchResults) {
        searchResults.style.display = 'block';
        searchResults.classList.add('has-results');
      }
      // Hide other sections
      const suggestions = searchModal.querySelector('[data-search-suggestions]');
      if (suggestions) suggestions.style.display = 'none';
    }
  
  // Hide search results
    function hideSearchResults() {
      if (searchResults) {
        searchResults.style.display = 'none';
        searchResults.classList.remove('has-results');
      }
      // Show other sections
      const suggestions = searchModal.querySelector('[data-search-suggestions]');
      if (suggestions) suggestions.style.display = 'block';
    }
  
  // Close on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && searchModal && searchModal.classList.contains('is-active')) {
        searchModal.classList.remove('is-active');
        document.body.style.overflow = '';
        if (searchInput) {
          searchInput.value = '';
        }
        hideSearchResults();
      }
    });

  // Test function for debugging
    window.testSearch = function(query = 'nike') {
      if (searchInput) {
        searchInput.value = query;
        performSearch(query);
      }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
// Force recompilation
  } catch(e) { console.error(e); }
})();

})();
